/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createBigNumberClass } from '../../factoriesAny.js';
export var BigNumberDependencies = {
  createBigNumberClass: createBigNumberClass
};